import(/* webpackMode: "eager" */ "/app/app/id/[sketchId]/page.tsx");
